module.exports = __webpack_public_path__ + "static/media/resources-color.225e9a21.svg";